import { API_URL } from "constants/variables";

export default function(path, defaultImage) {
  if (path) return "http://" + API_URL + "/storage" + path;
  return defaultImage;
}
